// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["admin-offer-refund-styles"], () => (__webpack_require__("./sources/ts/admin/offer-refund.ts")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["admin-offer-refund-styles"], () => (__webpack_require__("./sources/scss/admin/offer-refund.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
